import type { GeoJSONSource, Map as LibreMap } from 'maplibre-gl';
import type { GeoProjection } from '../../consumer/geospatial/projection';

export type ResearchLayerMap = Pick<
  LibreMap,
  'getSource' | 'addSource' | 'getLayer' | 'addLayer' | 'setLayoutProperty'
>;
/** Call after style.load, which permits adding sources/layers before provider
 * tiles finish. map.isStyleLoaded() waits for those tiles and is not this gate.
 */
export function installResearchLayers(
  map: ResearchLayerMap,
  data: GeoProjection,
  historical: boolean,
  enabled: readonly string[],
) {
  for (const id of ['nasa', 'noaa', 'boundary'] as const) {
    const sourceId = `vs09-${id}`;
    const source = map.getSource(sourceId) as GeoJSONSource | undefined;
    if (source) source.setData(data[id]);
    else map.addSource(sourceId, { type: 'geojson', data: data[id] });
    if (!map.getLayer(sourceId)) {
      if (id === 'boundary')
        map.addLayer({
          id: sourceId,
          type: 'line',
          source: sourceId,
          paint: { 'line-color': '#63c9f2', 'line-width': 2, 'line-dasharray': [3, 3] },
        });
      else
        map.addLayer({
          id: sourceId,
          type: 'circle',
          source: sourceId,
          paint: {
            'circle-radius': id === 'nasa' ? 6 : 7,
            'circle-color': id === 'nasa' ? '#f59e0b' : '#1686cb',
            'circle-stroke-width': 2,
            'circle-stroke-color': '#fff',
          },
        });
    }
    map.setLayoutProperty(
      sourceId,
      'visibility',
      historical && enabled.includes(id) ? 'visible' : 'none',
    );
  }
}
